module.exports = __webpack_public_path__ + "static/media/faucet.6d3e67ed.svg";